var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#b);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.413,16.664l.684-.787a.778.778,0,0,0,.2-.554v-.129a.4.4,0,0,0-.443-.443H.625a.313.313,0,0,0-.312.313v.625A.313.313,0,0,0,.625,16h.892a6.149,6.149,0,0,0-.43.481l-.219.273a.519.519,0,0,0-.109.581l.041.075a.475.475,0,0,0,.479.308h.185c.4,0,.623.1.623.355,0,.184-.164.321-.561.321a1.623,1.623,0,0,1-.6-.122c-.254-.152-.459-.137-.609.122l-.218.364a.421.421,0,0,0,.1.623,2.8,2.8,0,0,0,1.445.369,1.712,1.712,0,0,0,1.895-1.723A1.412,1.412,0,0,0,2.413,16.664ZM19.375,9.75H6.875a.625.625,0,0,0-.625.625v1.25a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20,11.625v-1.25A.625.625,0,0,0,19.375,9.75Zm0-6.25H6.875a.625.625,0,0,0-.625.625v1.25A.625.625,0,0,0,6.875,6h12.5A.625.625,0,0,0,20,5.375V4.125A.625.625,0,0,0,19.375,3.5Zm0,12.5H6.875a.625.625,0,0,0-.625.625v1.25a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20,17.875v-1.25A.625.625,0,0,0,19.375,16ZM.625,7.25h2.5a.312.312,0,0,0,.313-.312V6.313A.313.313,0,0,0,3.125,6H2.5V2.563a.312.312,0,0,0-.312-.312H1.25a.312.312,0,0,0-.279.173l-.312.625A.312.312,0,0,0,.937,3.5H1.25V6H.625a.313.313,0,0,0-.312.313v.625a.312.312,0,0,0,.312.313ZM.472,13.5H3.125a.313.313,0,0,0,.313-.312v-.625a.313.313,0,0,0-.312-.312H1.614c.129-.4,1.888-.73,1.888-2.2A1.582,1.582,0,0,0,1.765,8.5a1.894,1.894,0,0,0-1.58.732.386.386,0,0,0,.109.6l.335.269c.219.178.43.1.63-.1a.525.525,0,0,1,.37-.15.333.333,0,0,1,.362.342c0,.5-1.991.853-1.991,2.7v.156A.427.427,0,0,0,.472,13.5Z",
    transform: "translate(0 -1.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfo);
export default __webpack_public_path__ + "static/media/additional_info.16597e41547f7f9d7b2269ebed478567.svg";
export { ForwardRef as ReactComponent };